<div class="status-indicators-container">
  <!-- uniqueRemoteOrderIdStatus Indicator -->
  <span *ngIf="show('uniqueRemoteOrderIdStatus')" class="status-icon" [title]="('Remote Order Status' | languageString ) + ': ' + ( uniqueRemoteOrderIdStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">cloud_sync</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('uniqueRemoteOrderIdStatus') }}</span>
  </span>

  <!-- remoteOrderStateStatus Indicator -->
  <span *ngIf="show('remoteOrderStateStatus')" class="status-icon" [title]="('Remote Order Status' | languageString ) + ': ' + ( remoteOrderStateStatus | languageString )">
    <mat-icon >cloud_sync</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('remoteOrderStateStatus') }}</span>
  </span>

  <!-- ignoreStatus Indicator -->
  <span *ngIf="show('ignoreStatus')" class="status-icon" [title]="('Ignore Status' | languageString ) + ': ' + ( ignoreStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">cancel</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('ignoreStatus') }}</span>
  </span>

  <!-- userHoldStatus Indicator -->
  <span *ngIf="show('userHoldStatus')" class="status-icon" [title]="('User Hold Status' | languageString ) + ': ' + ( userHoldStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">pause</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('userHoldStatus') }}</span>
  </span>

  <!-- releaseStatus Indicator -->
  <span *ngIf="show('releaseStatus')" class="status-icon" [title]="('Remote Order Status' | languageString ) + ': ' + ( releaseStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings && releaseStatus === 'READY'" style="color: black">done_all</mat-icon>
    <mat-icon *ngIf="!showSymbolMeanings && releaseStatus === 'SUCCESS'" style="color: black">done</mat-icon>
    <mat-icon *ngIf="!showSymbolMeanings && releaseStatus === 'SUCCESS'" style="color: black">thumb_up</mat-icon>
    <mat-icon *ngIf="!showSymbolMeanings && releaseStatus === 'NOT_READY'" style="color: black">pending</mat-icon>
    <mat-icon *ngIf="!showSymbolMeanings && releaseStatus === 'IN_PROGRESS'" style="color: black">autorenew</mat-icon>
    <mat-icon *ngIf="!showSymbolMeanings && releaseStatus === 'ERROR'" style="color: red">error</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('releaseStatus') }}</span>
  </span>

  <!-- functionalStatus Indicator -->
  <span *ngIf="show('functionalStatus')" class="status-icon" [title]="( 'FunctionalStatusPrefix' | languageString ) + ': ' + ( functionalStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">settings</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('functionalStatus') }}</span>
  </span>

  <!-- ecommerceOrderStatus Indicator -->
  <span *ngIf="show('ecommerceOrderStatus')" class="status-icon" [title]="('Ecommerce Order Status' | languageString ) + ': ' + ( ecommerceOrderStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">cloud_sync</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('ecommerceOrderStatus') }}</span>
  </span>

  <!-- addressStatus Indicator -->
  <span *ngIf="show('addressStatus')" class="status-icon" [title]="( 'AddressStatusPrefix' | languageString ) + ': ' + ( addressStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">location_on</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('addressStatus') }}</span>
  </span>

  <!-- productStatus Indicator -->
  <span *ngIf="show('productStatus')" class="status-icon" [title]="( 'Product Status' | languageString ) + ': ' + ( productStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">inventory_2</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('productStatus') }}</span>
  </span>

  <!-- carrierServiceLevelStatus Indicator -->
  <span *ngIf="show('carrierServiceLevelStatus')" class="status-icon" [title]="( 'Carrier Service Level Status' | languageString ) + ': ' + ( carrierServiceLevelStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">local_shipping</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('carrierServiceLevelStatus') }}</span>
  </span>

  <!-- revenueStatus Indicator -->
  <span *ngIf="show('revenueStatus')" class="status-icon" [title]="( 'Revenue Status' | languageString ) + ': ' + ( revenueStatus | languageString )">
    <mat-icon *ngIf="!showSymbolMeanings">paid</mat-icon>
    <span *ngIf="showSymbolMeanings" class="status-icon-label">{{ getMessage('revenueStatus') }}</span>
  </span>
</div>
